module.exports = __webpack_public_path__ + "img/coupon-4-line.4793c98b.svg";